import { useEffect } from "react";
import { getTrans, getLatest } from "../utils/api";
import { useState } from "react";
import { Transaction } from "../utils/types";
export const useTransactions = (snackbarRef: any) => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [allTransactions, setAllTransactions] = useState<Transaction[]>([]);
  const [page, setPage] = useState<number>(1);

  useEffect(() => {
    if (allTransactions.length === 0) {
      fetchRecentTrans(page);
    } else {
      const lastIndex = page * 20;
      const firstIndex = lastIndex - 20;
      const currentItems = allTransactions.slice(firstIndex, lastIndex);
      setTransactions(currentItems);
      window.scrollTo(0, 0);
    }
  }, [page]);
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [totalPage, setTotalPage] = useState<number>(0);
  const fetchRecentTrans = async (page: number) => {
    setError("");
    setLoading(true);
    setAllTransactions([]);
    try {
      try {
        const res = await getLatest({ page: page });
        const data = res.data;
        setTransactions(data.items);
        setTotal(data.total_count);
        setTotalPage(data.total_pages);
      } catch (err) {
        setError("Failed to fetch transactions");
        console.error(err);
      }
    } finally {
      return setLoading(false);
    }
  };
  const fetchTransactions = async (filterss: any) => {
    setError("");
    setLoading(true);

    const filters = Object.fromEntries(
      Object.entries(filterss).filter(
        ([key, value]) => key === "search_query" && value,
      ),
    );

    try {
      const res = await getTrans(filters);
      const data = res.data;
      setPage(1);
      setTotal(data.length);
      setTotalPage(Math.ceil(data.length / 20));
      setAllTransactions(data);

      if (data.length > 20) {
        const lastIndex = page * 20;
        const firstIndex = lastIndex - 20;
        const currentItems = data.slice(firstIndex, lastIndex);
        setTransactions(currentItems);
      } else {
        setTransactions(data);
      }
    } catch (err) {
      setError("Failed to fetch transactions");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return {
    transactions,
    loading,
    error,
    fetchTransactions,
    fetchRecentTrans,
    total,
    setTransactions,
    page,
    totalPage,
    setPage,
  };
};
